import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue";
var _hoisted_1 = { class: "card" };
var _hoisted_2 = { class: "card-body" };
var _hoisted_3 = { class: "d-flex justify-content-between align-items-center mb-3" };
var _hoisted_4 = { class: "table-responsive" };
var _hoisted_5 = { class: "table table-striped table-hover" };
var _hoisted_6 = {
    "aria-label": "Paginación",
    class: "d-flex justify-content-start align-items-center mt-3"
};
var _hoisted_7 = { class: "pagination" };
var _hoisted_8 = { class: "page-item" };
var _hoisted_9 = ["disabled"];
var _hoisted_10 = { class: "page-item" };
var _hoisted_11 = ["disabled"];
var _hoisted_12 = { style: { "margin": "0 10px 1rem" } };
import { ref, onMounted } from 'vue';
import { getPlatforms } from '@/api/admin/platforms';
import { notify } from '@/utils/toast';
import { toast } from 'vue3-toastify';
var limit = 10;
export default /*@__PURE__*/ _defineComponent({
    __name: 'Platforms',
    setup: function (__props) {
        var platforms = ref([]);
        var page = ref(1);
        var lastPage = ref(1);
        onMounted(function () {
            fetchPlatforms();
        });
        function fetchPlatforms() {
            return __awaiter(this, void 0, void 0, function () {
                var response, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, getPlatforms({})];
                        case 1:
                            response = _a.sent();
                            platforms.value = response.data.data;
                            lastPage.value = response.data.lastPage;
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            if (error_1.response.status === 401) {
                                notify('No tiene permisos esta solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                            }
                            else if (error_1.response.status === 404) {
                                notify('No existe la solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                            }
                            else {
                                console.error(error_1.message);
                            }
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        var nextPage = function () {
            if (page.value < lastPage.value)
                page.value++;
        };
        var previousPage = function () {
            if (page.value > 1)
                page.value--;
        };
        return function (_ctx, _cache) {
            var _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "card-title" }, "Plataformas", -1)),
                    _createElementVNode("div", _hoisted_3, [
                        _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1)),
                        _createVNode(_component_router_link, {
                            class: "btn btn-primary",
                            to: "/admin/platforms/create"
                        }, {
                            default: _withCtx(function () { return _cache[0] || (_cache[0] = [
                                _createTextVNode("Nueva Plataforma")
                            ]); }),
                            _: 1
                        })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("table", _hoisted_5, [
                            _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", { scope: "col" }, "Acciones"),
                                    _createElementVNode("th", { scope: "col" }, "Nombre"),
                                    _createElementVNode("th", { scope: "col" }, "Grupos disponibles / Activos"),
                                    _createElementVNode("th", { scope: "col" }, "Perfiles disponibles"),
                                    _createElementVNode("th", { scope: "col" }, "Costo mínimo"),
                                    _createElementVNode("th", { scope: "col" }, "Baneados")
                                ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platforms.value, function (pl) {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: pl.id
                                    }, [
                                        _cache[2] || (_cache[2] = _createElementVNode("td", null, "1", -1)),
                                        _createElementVNode("td", null, _toDisplayString(pl.name), 1),
                                        _createElementVNode("td", null, _toDisplayString(pl.available_grs) + " / " + _toDisplayString(pl.active_grs), 1),
                                        _createElementVNode("td", null, _toDisplayString(pl.used_prf) + " / " + _toDisplayString(pl.available_prf), 1),
                                        _createElementVNode("td", null, _toDisplayString(pl.min_cost), 1),
                                        _createElementVNode("td", null, _toDisplayString(pl.banned_grs), 1)
                                    ]));
                                }), 128))
                            ])
                        ])
                    ]),
                    _createElementVNode("nav", _hoisted_6, [
                        _createElementVNode("ul", _hoisted_7, [
                            _createElementVNode("li", _hoisted_8, [
                                _createElementVNode("button", {
                                    class: "page-link",
                                    onClick: previousPage,
                                    disabled: page.value <= 1
                                }, "Anterior", 8, _hoisted_9)
                            ]),
                            _cache[4] || (_cache[4] = _createStaticVNode("<li class=\"page-item\"><button class=\"page-link\" href=\"#\">1</button></li><li class=\"page-item\"><button class=\"page-link\" href=\"#\">2</button></li><li class=\"page-item\"><button class=\"page-link\" href=\"#\">3</button></li>", 3)),
                            _createElementVNode("li", _hoisted_10, [
                                _createElementVNode("button", {
                                    class: "page-link",
                                    onClick: nextPage,
                                    disabled: page.value >= lastPage.value
                                }, "Siguiente", 8, _hoisted_11)
                            ])
                        ]),
                        _createElementVNode("span", _hoisted_12, "Página " + _toDisplayString(page.value) + " de " + _toDisplayString(lastPage.value), 1)
                    ])
                ])
            ]));
        };
    }
});
